import { Component } from '@angular/core';

@Component({
  selector: 'prcins-mobile-banner',
  templateUrl: './mobile-banner.component.html',
  styleUrls: ['./mobile-banner.component.css']
})
export class MobileBannerComponent {}
